import FormBuilderConfig from "../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ITextBuilder from "../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import ISelectBuilder from "../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import IDateBuilder from "../../../toolkit/baseForms2/iDateBuilder/IDateBuilder";
import ICheckBuilder from "../../../toolkit/baseForms2/iCheckBuilder/ICheckBuilder";
import IClubSelectorBuilder from "../../../toolkit/baseForms2Commons/iClubSelectorBuilder/IClubSelectorBuilder";

export type Inputs =
  | "tipoBusqueda"
  | "idClubFecha"
  | "idClubMembresia"
  | "idPublico"
  | "fechaInicio"
  | "fechaFin"
  | "ignorarAut"
  | "folioFactura";

export type Buttons = "buscar";

const hiddenIfNotFechas = values =>
  values.tipoBusqueda === "FACTURA" || values.tipoBusqueda === "MEMBRESIA";
const hiddenIfNotFactura = values => values.tipoBusqueda !== "FACTURA";
const hiddenIfNotMembresia = values => values.tipoBusqueda !== "MEMBRESIA";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "tipoBusqueda",
      label: "Tipo de Búsqueda",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Por Fechas",
        data: [
          { value: "MEMBRESIA", label: "Por Membresía" },
          { value: "FACTURA", label: "Por Factura" }
        ]
      }
    },
    {
      name: "idClubFecha",
      label: "* Club",
      bts: { mCol: 2 },
      component: IClubSelectorBuilder,
      props: {
        useSessionClub: true,
        hidden: hiddenIfNotFechas
      }
    },
    {
      name: "idClubMembresia",
      label: "* Club",
      bts: { mCol: 2 },
      component: IClubSelectorBuilder,
      props: {
        hidden: hiddenIfNotMembresia
      }
    },
    {
      name: "folioFactura",
      label: "Folio de Factura",
      bts: { mCol: 2 },
      component: ITextBuilder,
      props: {
        uppercase: true,
        hidden: hiddenIfNotFactura
      }
    },
    {
      name: "idPublico",
      label: "Membresía",
      bts: { mCol: 2 },
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        hidden: hiddenIfNotMembresia
      }
    },
    {
      name: "fechaInicio",
      label: "Fecha inicio",
      bts: { mCol: 2 },
      component: IDateBuilder,
      props: {
        hidden: hiddenIfNotFechas
      }
    },
    {
      name: "fechaFin",
      label: "Fecha fin",
      bts: { mCol: 2 },
      component: IDateBuilder,
      props: {
        hidden: hiddenIfNotFechas
      }
    },
    {
      name: "ignorarAut",
      label: "Ignorar autorizados",
      bts: { mCol: 2 },
      component: ICheckBuilder,
      props: {
        hidden: hiddenIfNotFechas
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: { mCol: 2 },
      component: IButtonBuilder
    }
  ],
  validations: {
    idClubFecha: {
      requiredIfFechas: {
        validator: (value, formValue) => !formValue.tipoBusqueda && !value,
        message: () => "Campo obligatorio"
      }
    },
    idClubMembresia: {
      requiredIfMembresia: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda === "MEMBRESIA" && !value,
        message: () => "Campo obligatorio"
      }
    },
    folioFactura: {
      requiredIfFactura: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda === "FACTURA" && !value,
        message: () => "Campo obligatorio"
      }
    },
    idPublico: {
      requiredIfMembresia: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda === "MEMBRESIA" && !value,
        message: () => "Campo obligatorio"
      }
    },
    fechaInicio: {
      requiredIfFechas: {
        validator: (value, formValue) => !formValue.tipoBusqueda && !value,
        message: () => "Campo obligatorio",
        partners: ["fechaFin"]
      }
    },
    fechaFin: {
      requiredIfFechas: {
        validator: (value, formValue) => !formValue.tipoBusqueda && !value,
        message: () => "Campo obligatorio",
        partners: ["fechaInicio"]
      },
      menorAFechaInicio: {
        validator: (value, formValue) => {
          if (!value || !formValue.fechaInicio || formValue.tipoBusqueda) {
            return false;
          }
          const inicio = new Date(formValue.fechaInicio);
          const fin = new Date(value);
          return fin < inicio;
        },
        message: () => "No puede ser menor que la Fecha Inicio",
        partners: ["fechaInicio"]
      }
    }
  },
  rows: [
    [
      "tipoBusqueda",
      "idClubFecha",
      "idClubMembresia",
      "folioFactura",
      "idPublico",
      "fechaInicio",
      "fechaFin",
      "ignorarAut",
      "buscar"
    ]
  ]
};
